import { render, staticRenderFns } from "./kids_layout.vue?vue&type=template&id=68167525&scoped=true&"
import script from "./kids_layout.vue?vue&type=script&lang=js&"
export * from "./kids_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68167525",
  null
  
)

export default component.exports